<!-- **
  * (name1 value1 name2 value2)
* -->
<template>
    <div class="titleTips">
        <template v-if="listData.length">
            <div>(</div>
            <TitleTipsItem :listData="listData" />
            <div>)</div>
        </template>
    </div>
</template>

<script>

export default {
    components: { TitleTipsItem: () => import('./TitleTipsItem') },
    name: 'TitleTips',
    props: {
        listData: {
            type: Array,
            default: () => []
        }
    },
}
</script>

<style lang="scss" scoped>
.titleTips {
    @include setFlexStart;
    max-width: 280px;
    margin-right: 15px;

    &>div {
        display: flex;
        margin-left: 5px;
    }
}
</style>